import React from 'react';
import { CtaButton } from './CtaButton';
import { PRICE_LABEL } from '../data/offer';
export function FinalCta() {
  return <section className="w-full bg-navy-950 text-white" data-id="element-27" data-mp="vghgnn67c9ny">
      <div className="mx-auto max-w-3xl px-4 py-16 text-center sm:px-6 sm:py-24" data-id="element-28" data-mp="19epbnpjoh0wh">
        <h2 className="font-display text-3xl font-extrabold leading-tight tracking-tight sm:text-5xl" data-id="element-29" data-mp="19cmd2h4glzg5">
          Tu próximo partido puede jugarse distinto
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg text-white/75" data-id="element-30" data-mp="1jbk8m40ayt8n">
          Accedé al sistema completo por solo{' '}
          <strong className="font-semibold text-lime-400" data-id="element-31" data-mp="1ebxu7r8qn6y9">{PRICE_LABEL} ARS</strong> y empezá a
          aplicarlo hoy mismo.
        </p>
        <div className="mt-9 flex justify-center" data-id="element-32" data-mp="1o3bq7p1hdomn">
          <CtaButton size="lg" location="cta-final" data-id="element-33" data-mp="1o4n108tcfwn9">
            ¡Sí, quiero dominar la pista ahora!
          </CtaButton>
        </div>
        <p className="mt-4 text-sm text-white/55" data-id="element-34" data-mp="1x4tevvsyeymy">
          Descarga inmediata · Garantía de 7 días · Manual + 3 bonus
        </p>
      </div>
    </section>;
}